import React from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";

export function withRouter(Component) {
	function WithRouterWrapper(props) {
		const navigate = useNavigate();
		const params = useParams();
		const location = useLocation();
		const history = {
			push: navigate,
			replace: (to) => navigate(to, { replace: true }),
			goBack: () => navigate(-1),
			location,
			length: window.history.length,
		};
		const match = { params };
		return (
			<Component
				{...props}
				history={history}
				match={match}
				location={location}
			/>
		);
	}
	WithRouterWrapper.displayName = `withRouter(${Component.displayName || Component.name || "Component"})`;
	return WithRouterWrapper;
}
